import { FetchState, hasValue } from "../Models/Client/FetchState"
import { useAppState } from "./useReduxState"
import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { getInstance } from "../Actions/API/AppInstance/AppInstanceActions"
import { APIAppInstanceState } from "../Reducers/API/AppInstance/AppInstanceReducer"
import { isAPIError } from "../Models/API/Error"

export function useAppInstance(
    appID?: string
): FetchState<APIAppInstanceState> {
    const dispatch = useDispatch()
    const fetchState = useAppState(state => {
        if (appID === undefined) {
            return undefined
        }

        return state.api.apps.apps.records.get(appID)
    })

    useEffect(() => {
        const isAlreadyFetchedIncludingStats =
            hasValue(fetchState) &&
            fetchState.value.job_stats !== null &&
            !isAPIError(fetchState.value.job_stats)

        if (
            appID === undefined ||
            fetchState === "loading" ||
            isAlreadyFetchedIncludingStats
        ) {
            return
        }

        dispatch(getInstance(appID))
    }, [appID, fetchState, dispatch])

    return fetchState
}
